import React, {Component} from 'react';

class ConCom extends Component {

   render(){ 
    var concert = require.context("../../../public/images/Photography/Concert/", false, /.*\.jpg$/);
  return (
    
    <div class="phs1-item">
    <div class="phs1-container">
        <div class="phs1-item">
        {concert.keys().map((imgs)=>
            <img src={process.env.PUBLIC_URL + "/images/Photography/Concert/" + imgs.split("/").pop() } class="phs1-img"/>
        )}
        </div>
    </div>
    </div>
  );
}
}
export default ConCom;
